import Api from "@/libraries/Api";
import FallbackDB from "@/libraries/localStorage";
import { getNow } from "@/helpers/format_date";

export default {
    TICK_TIME: 250,
    queue: [],

    REPEAT_UNTIL_SUCCESS: 1,
    HIGH_PRIORITY: 10,
    REPLACE_EQUAL: 100,

    locked: false,

    // Методы обработки запросов в очереди:
    async _loop() {
        await Promise.allSettled( this.queue.map((v, n) => this.doRequest(n)) );
        this.queue = this.queue.filter(v => !v.request_done_time);
        FallbackDB.save('ajax_requests', this.queue);
    },
    async loop() { // Проходится по очереди поставленных запросов в Api и выполняет каждый их них. В случае если action поставлен с параметром repeat_until_success, то он не удалиться из очереди до тех пор, пока не сервер не выполнит его удачно
        if (this.locked) {
            return;
        }
        this.locked = true;
        await this._loop();
        this.locked = false;
    },
    restore() { // Восстанавливает запросы, которые не удалось сделать до прошлой выгрузки приложения из памяти
        let requests = FallbackDB.restore('ajax_requests');
        for (const request of requests) {
            try {
                const response = this.add(request);
                if (!request.onSuccess) {
                    continue;
                }
                eval(request.onSuccess + '(response)');
            } catch (e) {
                if (!request.onFail) {
                    throw e;
                }
                eval(request.onFail + '(e)');
            }
        }
    },
    init() { // Вызывает loop каждые TICK_TIME секунд (если прошлый вызов уже завершился, иначе ждёт)
        setInterval(() => this.loop(), this.TICK_TIME);
        this.loop();
    },
    async doRequest(n) { // Метод который реально исполняет запрос и вызывает необходимые callback-и
        const a = this.queue[n];
        const method = a.request.method || 'get';

        a.request_done_time = 0;
        try {
            const response = await Api[method](a.request.uri, a.request.data);
            a.request_done_time = +getNow();
            a.resolve(response);
        } catch (e) {
            // Если вернулась ошибка авторизации, то повторять такой запрос не нужно
            const is401 = +e?.status === 401;
            if (is401) {
                a.request_done_time = +getNow();
                return;
            }

            // Если стоит "выполнять запрос пока не будет успешного ответа", то ставим его на повтор
            if (!a.repeatUntilSuccess) {
                a.request_done_time = +getNow();
                a.reject(e.data);
            }
        }
    },

    // Методы добавления запросов в очередь:
    add(pack) {
        return new Promise((resolve, reject) => {
            this.queue.push({
                ...pack,
                resolve,
                reject,
                create_request_time: +getNow(),
            });
        });
    },
    addToTop(pack) { // Добавляет action в самый верх очереди событий (чтобы выполнилось первым)
        return new Promise((resolve, reject) => {
            const firstAction = {
                ...pack,
                resolve,
                reject,
                create_request_time: +getNow(),
            };
            this.queue = [firstAction].concat(this.queue);
        });
    },
    replace(pack) { // Заменит в queue action с таким же uri, а если его нет, то создаст его внизу списка
        const found = this.queue.findIndex(v => v.request.uri === pack.request.uri);
        if (~found) {
            return new Promise((resolve, reject) => {
                this.queue[found] = {
                    ...pack,
                    resolve,
                    reject,
                    create_request_time: +getNow(),
                };
            });
        }
        return this.add(pack);
    },
    replaceToTop(pack) {
        const found = this.queue.find(v => v.request.uri === pack.request.uri);
        if (found) {
            return new Promise((resolve, reject) => {
                this.queue[found] = {
                    ...pack,
                    resolve,
                    reject,
                    create_request_time: +getNow(),
                };
            });
        }
        return this.addToTop(pack);
    },
    _call(uri, method, data, params, onSuccess, onFail) { // Всё публичное апи вызывает этот _call с разными параметрами. Он же добавляет запрос в очередь
        const repeatUntilSuccess = Boolean(params & this.REPEAT_UNTIL_SUCCESS);
        const funcPrefix = Boolean(params & this.REPLACE_EQUAL) ? 'replace' : 'add';
        const funcPostfix = Boolean(params & this.HIGH_PRIORITY) ? 'ToTop' : '';
        const func = funcPrefix + funcPostfix;

        return this[func]({
            request: {uri, method, data},
            repeatUntilSuccess,
            onSuccess,
            onFail,
        });
    },

    // Публичное api класса:
    get(uri, data = [], params = 0, onSuccess = null, onFail = null) {
        return this._call(uri, 'get', data, params, onSuccess, onFail);
    },
    post(uri, data, params = 0, onSuccess = null, onFail = null) {
        return this._call(uri, 'post', data, params, onSuccess, onFail);
    },
    put(uri, data, params = 0, onSuccess = null, onFail = null) {
        return this._call(uri, 'put', data, params, onSuccess, onFail);
    },
    patch(uri, data, params = 0, onSuccess = null, onFail = null) {
        return this._call(uri, 'patch', data, params, onSuccess, onFail);
    },
    delete(uri, data = [], params = 0, onSuccess = null, onFail = null) {
        return this._call(uri, 'delete', data, params, onSuccess, onFail);
    }
}